import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { RequireAdmin, RequireAuth } from "./components/RequireAuth";
import { usePlaylistSwitchReset } from "./lib/usePlaylistSwitchReset";
import HubPage from "./pages/HubPage";
import DownloadPage from "./pages/DownloadPage";
import LoginPage from "./pages/LoginPage";
import ChangePasswordPage from "./pages/ChangePasswordPage";
import LiveTVPage from "./pages/LiveTVPage";
import MoviesPage from "./pages/MoviesPage";
import SeriesPage from "./pages/SeriesPage";
import SeriesDetailPage from "./pages/SeriesDetailPage";
import CatchupPage from "./pages/CatchupPage";
import GuidePage from "./pages/GuidePage";
import CatchupChannelPage from "./pages/CatchupChannelPage";
import SearchPage from "./pages/SearchPage";
import FavoritesPage from "./pages/FavoritesPage";
import SettingsPage from "./pages/SettingsPage";
import AdminPage from "./pages/AdminPage";
import WatchPage from "./pages/WatchPage";

export default function App() {
  const location = useLocation();
  usePlaylistSwitchReset();
  return (
    <AnimatePresence mode="wait" initial={false}>
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Navigate to="/hub" replace />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/change-password" element={<RequireAuth><ChangePasswordPage /></RequireAuth>} />
        <Route path="/hub" element={<RequireAuth><HubPage /></RequireAuth>} />
        <Route path="/livetv" element={<RequireAuth><LiveTVPage /></RequireAuth>} />
        <Route path="/movies" element={<RequireAuth><MoviesPage /></RequireAuth>} />
        <Route path="/series" element={<RequireAuth><SeriesPage /></RequireAuth>} />
        <Route path="/series/:seriesId" element={<RequireAuth><SeriesDetailPage /></RequireAuth>} />
        <Route path="/guide" element={<RequireAuth><GuidePage /></RequireAuth>} />
        <Route path="/catchup" element={<RequireAuth><CatchupPage /></RequireAuth>} />
        <Route path="/catchup/:streamId" element={<RequireAuth><CatchupChannelPage /></RequireAuth>} />
        <Route path="/search" element={<RequireAuth><SearchPage /></RequireAuth>} />
        <Route path="/favorites" element={<RequireAuth><FavoritesPage /></RequireAuth>} />
        <Route path="/download" element={<RequireAuth><DownloadPage /></RequireAuth>} />
        <Route path="/settings" element={<RequireAuth><SettingsPage /></RequireAuth>} />
        <Route path="/admin" element={<RequireAdmin><AdminPage /></RequireAdmin>} />
        <Route path="/watch/:kind/:id" element={<RequireAuth><WatchPage /></RequireAuth>} />
        <Route path="*" element={<Navigate to="/hub" replace />} />
      </Routes>
    </AnimatePresence>
  );
}
